import SpeakButton from "@/components/SpeakButton";
import { useT } from "@/i18n";
import { SAMPLE, SUBJECT, FRAMINGS, PHOTO_TEXT } from "@/components/photo/content";

export default function Framings() {
  const { lang } = useT();
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{PHOTO_TEXT[lang].framing}</h3><SpeakButton compact mascot="lumi" text={PHOTO_TEXT[lang].framing} testId="ask-photo-framing" /></div>
      <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {FRAMINGS.map((f) => (
          <div key={f.id} className="bg-white rounded-3xl p-2 shadow-md" data-testid={`framing-${f.id}`}>
            <div className="rounded-2xl overflow-hidden aspect-square">
              <img src={SAMPLE} alt="" className="w-full h-full object-cover" style={{ transform: `scale(${f.scale})`, transformOrigin: SUBJECT, objectPosition: SUBJECT }} />
            </div>
            <p className="font-fredoka font-bold text-blue-950 mt-2 px-1">{f[lang][0]}</p>
            <p className="text-xs sm:text-sm font-semibold text-blue-900/80 px-1 pb-1">{f[lang][1]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
